import { render, staticRenderFns } from "./DeleteForum.vue?vue&type=template&id=62193374&"
import script from "./DeleteForum.vue?vue&type=script&lang=js&"
export * from "./DeleteForum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports